import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const AddTopicWrapper = styled.div`
  .topic-container {
    padding: 0px 16px 40px 16px;
    ${responsive.MOBILE`
      padding: 16px;
    `}

    .MuiFormGroup-root {
      margin-top: 0;
    }
    .topic-type-radio-group {
      margin-top: 24px;

      ${responsive.MOBILE`
        margin-top: 0;
      `}
    }
  }

  .accordion-header:not(:first-of-type) {
    margin-top: 24px;

    ${responsive.MOBILE`
      margin-top: 16px;
    `}
  }

  .MuiGrid2-container {
    padding-right: 0px;
  }

  .dashed-line {
    border: 1px dashed ${COLORS.primary_light_blue4};
  }

  .preferences-container {
    margin: 24px 16px 0 16px;
    ${responsive.MOBILE`
      margin: 16px 16px 0 16px;
    `}

    .select-preference {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }

    .checkbox-container {
    }
  }

  .locale-container {
    padding-left: 16px;
    padding-bottom: 24px;
    ${responsive.MOBILE`
      padding: 0 16px 16px 16px;
    `}
  }

  .exception-container {
    padding: 24px 16px;
    ${responsive.MOBILE`
      padding: 0 16px 16px 16px;
    `}
    .add-button {
      margin-top: 30px;
      ${responsive.MOBILE`
          margin-top: 10px;
       width:100%;
      `}
    }
    .add-button-container {
      ${responsive.MOBILE`
       width:100%;
      `}
    }

    .form-container {
      padding-bottom: 24px;
    }

    .MuiGrid2-root {
      padding-right: 18px;
      ${responsive.MOBILE`
         padding: 16px 0px 0px 0px ;
      `}
    }
    .table-container {
      margin-top: 24px;
    }
  }
`;
